var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.675 10.8167C13.65 10.8167 12.6583 10.65 11.7333 10.35C11.5884 10.3012 11.4326 10.294 11.2838 10.3294C11.135 10.3648 10.9992 10.4412 10.8917 10.55L9.58333 12.1917C7.225 11.0667 5.01667 8.94167 3.84167 6.5L5.46667 5.11667C5.69167 4.88333 5.75833 4.55833 5.66667 4.26667C5.35833 3.34167 5.2 2.35 5.2 1.325C5.2 0.875 4.825 0.5 4.375 0.5H1.49167C1.04167 0.5 0.5 0.7 0.5 1.325C0.5 9.06667 6.94167 15.5 14.675 15.5C15.2667 15.5 15.5 14.975 15.5 14.5167V11.6417C15.5 11.1917 15.125 10.8167 14.675 10.8167Z",
    fill: "#CB2129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.079b6456be0217776fa7cff230f21d78.svg";
export { ForwardRef as ReactComponent };